<template>
    <div>
        <div class='footer-column-title'>
            Help
        </div>
        <div class='footer-column-links'>
            <div @click="onClickLink('https://commercialonlineorders.majestic.co.uk/', true)"><a class="footer-link">Ordering</a></div>
            <div @click="onClickLink('how-does-it-work/deliveries-and-supply')"><a class="footer-link">Deliveries</a></div>
            <div @click="onClickLink('how-does-it-work/contact-us')"><a class="footer-link">Product Enquiries</a></div>
            <div @click="onClickLink('how-does-it-work/contact-us')"><a class="footer-link">Technical Support</a></div>
            <div @click="onClickLink('how-does-it-work/faq')"><a class="footer-link">FAQ's</a></div>
            <div @click="onClickLink('how-does-it-work/contact-us')"><a class="footer-link">Contact Us</a></div>

        </div>
    </div>
</template>
<script>
export default {
    methods: {
          onClickLink(page, exteneral = false) {
            if(!exteneral){
                this.$router.push(`/${page}`);
            }
            else{
                window.location.href = page;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.contact-us-button{
    background-color: var(--maj-slate);
    color: white;
    padding: 16px;
    border-radius: 12px;
    margin-top: 12px;
    cursor: pointer;
}
</style>